import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getProductSelector = (state: ApplicationState) => state.components.productSelector;
